import { useEffect } from "react";

export function useSetHeightVariable() {
  const setInitialHeight = () => {
    const vh = window.innerHeight * 0.01;
    document.documentElement.style.setProperty("--vh", `${vh}px`);
  };

  useEffect(() => {
    window.addEventListener("load", setInitialHeight);
  }, []);
}

export default useSetHeightVariable;
